// extracted by mini-css-extract-plugin
module.exports = {"containerPadding":"BodyWrapper_containerPadding__1m5qn","leftRightPadding":"BodyWrapper_leftRightPadding__3Wn0z"};